import { render, staticRenderFns } from "./BzShareCard.vue?vue&type=template&id=9c219d96&scoped=true&"
import script from "./BzShareCard.vue?vue&type=script&lang=js&"
export * from "./BzShareCard.vue?vue&type=script&lang=js&"
import style0 from "./BzShareCard.vue?vue&type=style&index=0&id=9c219d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c219d96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
